module.exports = __webpack_public_path__ + "static/media/small_calf.cb02b133.png";